import { SxProps } from '@mui/system/styleFunctionSx';
import Box from '@mui/material/Box';
import { PlatformIcon } from './GamePlatformIcon';
import { Platform } from '../../../functions/src/types/Platform';
import { Variant } from '@mui/material/styles/createTypography';

type GamePlatformsProps = {
  supportedPlatforms: Platform[];
  typographyVariant?: Variant;
  wrapperSX?: SxProps;
};

// The order in which the supportedPlatforms array will be sorted to ensure the icons appear in the same order for every game
const platformSortOrder: Platform[] = [
  'web',
  'android',
  'apple',
  'windows',
  'xbox',
  'playstation',
  'linux',
];

export function GamePlatforms({
  supportedPlatforms,
  typographyVariant,
  wrapperSX = {},
}: GamePlatformsProps) {
  if (!supportedPlatforms || supportedPlatforms.length === 0) return null;

  const orderedPlatforms = supportedPlatforms.sort(
    (a, b) => platformSortOrder.indexOf(a) - platformSortOrder.indexOf(b),
  );

  const platformIcons: JSX.Element[] = orderedPlatforms.map((platform) => {
    return (
      <PlatformIcon
        platform={platform}
        key={platform}
        typographyVariant={typographyVariant}
      />
    );
  });

  return (
    <Box
      display={'flex'}
      flexDirection={'row'}
      alignItems={'center'}
      sx={{
        '& > *': {
          mx: '8px!important',
        },
        '& > *:first-of-type': {
          ml: '0!important',
        },
        '& > *:last-of-type': {
          mr: '0!important',
        },
        ...wrapperSX,
      }}
    >
      {platformIcons.map((icon) => icon)}
    </Box>
  );
}
